// what we put into the access token
export interface UserInfo {
  // pid of the role
  role: string;
  firstName?: string;
  companyId: string;
  _id: string;
}

export type Auth = UserInfo & {
  accessToken: string;
  stayLoggedIn?: boolean;
  // The user's real (home) company from the token. `companyId` may be
  // overridden to the active org while a switcher selection is in effect.
  homeCompanyId?: string;
  // The org currently selected in the sidebar switcher (undefined => home).
  activeCompanyId?: string;
};

export interface Role {
  name: string;
  pid: string;
}

export const ROLES: { [role: string]: Role } = {
  ARTYC_ADMIN: {
    name: 'Artyc Admin',
    pid: '13b3c08c-aa46-4779-aa40-94b92681cd78',
  },
  ARTYC_EMPLOYEE: {
    name: 'Artyc Employee',
    pid: '05da77d5-d489-405b-813c-b0754cd0ecdf',
  },
  COMPANY_ADMIN: {
    name: 'Company Admin',
    pid: 'f603928e-effa-4cf4-8e76-358b41d68534',
  },
  COMPANY_EMPLOYEE: {
    name: 'Company Employee',
    pid: 'ad4d463e-af60-44b9-a648-fe6e47cf5461',
  },
  // Scoped roles (granted per child/parent company on the backend).
  ADMIN: {
    name: 'Admin',
    pid: '12546292-a97a-4a9c-bc05-d065022057a9',
  },
  OPERATOR: {
    name: 'Operator',
    pid: '2d843107-1472-4444-a8fe-7cd3d12de858',
  },
  VIEWER: {
    name: 'Viewer',
    pid: '16f2f39a-08ac-4a9e-af03-bac4cc42a65f',
  },
};
